import mixpanel from "common/mixpanel";
import mixpanelLastTouch from "common/mixpanel-last-touch";
import pageData from "common/page-data";

const mixpanelService = {
  identifyUser() {
    const user = pageData.get("mixpanelUser");
    if (user === undefined) return;

    const persistedId = mixpanel.get_property("$user_id");
    if (persistedId && (!user || persistedId !== String(user.id))) {
      mixpanel.reset();
      mixpanelLastTouch.registerCampaignParams(mixpanel);
    }
    if (!user) return;

    mixpanel.identify(String(user.id));
    mixpanel.people.set({
      $email: user.email,
      $name: user.fullName,
      account_id: user.accountId,
      partner_id: user.partnerId
    });
  },
  track(name, attributes = {}, callback) {
    // pageData.get returns a default {}
    const page = pageData.get("mixpanelData");
    const data = { ...attributes, ...page };
    return mixpanel.track(name, data, callback);
  },
  trackClick(name, attributes, callback) {
    return () => mixpanelService.track(name, attributes, callback);
  },
  trackLink(query, eventName, properties) {
    return mixpanel.track_links(query, eventName, properties);
  }
};

export default mixpanelService;
